export default {
  title: 'OneVision',
  faviconPath: '/static/icons/favicon-onevision.ico',
  defaultCss: 'onevision.css',
};
